// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610140636/js/" + chunkId + "." + {"44":"2d31d6a4","225":"ff5109dc","481":"e040cf38","486":"2e9cc66c","770":"071769a6"}[chunkId] + ".0.5817299160702146.chunk.js";
};